/* tslint:disable */
/* eslint-disable */
/**
 * Illio Wealth API
 * [Environment: dev], Manage your account, add trades, view portfolio performance and pnl
 *
 * The version of the OpenAPI document: 1.0
 * Contact: support@illio.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { AllocationDTO } from './allocation-dto';
import { EsgScoreWithRAG } from './esg-score-with-rag';
import { PortfolioBenchmarkIndex } from './portfolio-benchmark-index';
import { PortfolioCustodian } from './portfolio-custodian';

/**
 * 
 * @export
 * @interface PortfolioDTOWithDetailsV3
 */
export interface PortfolioDTOWithDetailsV3 {
    /**
     * 
     * @type {string}
     * @memberof PortfolioDTOWithDetailsV3
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof PortfolioDTOWithDetailsV3
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof PortfolioDTOWithDetailsV3
     */
    'workgroup': string;
    /**
     * 
     * @type {string}
     * @memberof PortfolioDTOWithDetailsV3
     */
    'accessType': PortfolioDTOWithDetailsV3AccessTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof PortfolioDTOWithDetailsV3
     */
    'workgroupType': PortfolioDTOWithDetailsV3WorkgroupTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof PortfolioDTOWithDetailsV3
     */
    'portfolioType': PortfolioDTOWithDetailsV3PortfolioTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof PortfolioDTOWithDetailsV3
     */
    'inceptionDate': string;
    /**
     * 
     * @type {number}
     * @memberof PortfolioDTOWithDetailsV3
     */
    'unconfirmedTrades': number;
    /**
     * 
     * @type {number}
     * @memberof PortfolioDTOWithDetailsV3
     */
    'confirmedTrades': number;
    /**
     * 
     * @type {string}
     * @memberof PortfolioDTOWithDetailsV3
     */
    'currencyCode': PortfolioDTOWithDetailsV3CurrencyCodeEnum;
    /**
     * 
     * @type {string}
     * @memberof PortfolioDTOWithDetailsV3
     */
    'currencySymbol': string;
    /**
     * 
     * @type {number}
     * @memberof PortfolioDTOWithDetailsV3
     */
    'totalWealth'?: number;
    /**
     * 
     * @type {number}
     * @memberof PortfolioDTOWithDetailsV3
     */
    'totalProfitAndLoss'?: number;
    /**
     * 
     * @type {number}
     * @memberof PortfolioDTOWithDetailsV3
     */
    'historicPnl': number;
    /**
     * 
     * @type {number}
     * @memberof PortfolioDTOWithDetailsV3
     */
    'performance': number;
    /**
     * 
     * @type {{ [key: string]: Array<AllocationDTO>; }}
     * @memberof PortfolioDTOWithDetailsV3
     */
    'allocation'?: { [key: string]: Array<AllocationDTO>; };
    /**
     * 
     * @type {PortfolioBenchmarkIndex}
     * @memberof PortfolioDTOWithDetailsV3
     */
    'benchmarkIndex': PortfolioBenchmarkIndex;
    /**
     * 
     * @type {Array<PortfolioCustodian>}
     * @memberof PortfolioDTOWithDetailsV3
     */
    'custodians': Array<PortfolioCustodian>;
    /**
     * 
     * @type {Array<PortfolioCustodian>}
     * @memberof PortfolioDTOWithDetailsV3
     */
    'additionalCustodians': Array<PortfolioCustodian>;
    /**
     * 
     * @type {string}
     * @memberof PortfolioDTOWithDetailsV3
     */
    'pnlStatus': PortfolioDTOWithDetailsV3PnlStatusEnum;
    /**
     * 
     * @type {Set<string>}
     * @memberof PortfolioDTOWithDetailsV3
     */
    'instrumentCurrencies': Set<string>;
    /**
     * 
     * @type {number}
     * @memberof PortfolioDTOWithDetailsV3
     */
    'yestPnl': number;
    /**
     * 
     * @type {number}
     * @memberof PortfolioDTOWithDetailsV3
     */
    'yestPerf': number;
    /**
     * 
     * @type {EsgScoreWithRAG}
     * @memberof PortfolioDTOWithDetailsV3
     */
    'esg': EsgScoreWithRAG;
    /**
     * 
     * @type {string}
     * @memberof PortfolioDTOWithDetailsV3
     */
    'summary'?: string;
    /**
     * 
     * @type {string}
     * @memberof PortfolioDTOWithDetailsV3
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof PortfolioDTOWithDetailsV3
     */
    'subheading'?: string;
    /**
     * 
     * @type {Set<string>}
     * @memberof PortfolioDTOWithDetailsV3
     */
    'tags'?: Set<string>;
    /**
     * 
     * @type {string}
     * @memberof PortfolioDTOWithDetailsV3
     */
    'imageUrl'?: string;
    /**
     * 
     * @type {number}
     * @memberof PortfolioDTOWithDetailsV3
     */
    'volatility'?: number;
    /**
     * 
     * @type {number}
     * @memberof PortfolioDTOWithDetailsV3
     */
    'annualReturn'?: number;
    /**
     * 
     * @type {number}
     * @memberof PortfolioDTOWithDetailsV3
     */
    'biggestDrawdown'?: number;
    /**
     * 
     * @type {string}
     * @memberof PortfolioDTOWithDetailsV3
     */
    'tradeEpochDate': string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof PortfolioDTOWithDetailsV3
     */
    'integrations': { [key: string]: string; };
    /**
     * 
     * @type {boolean}
     * @memberof PortfolioDTOWithDetailsV3
     */
    'hasOptions': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PortfolioDTOWithDetailsV3
     */
    'hasBonds': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PortfolioDTOWithDetailsV3
     */
    'managedExternally': boolean;
    /**
     * 
     * @type {string}
     * @memberof PortfolioDTOWithDetailsV3
     */
    'shadowPortfolio'?: string;
    /**
     * 
     * @type {string}
     * @memberof PortfolioDTOWithDetailsV3
     */
    'originalPortfolio'?: string;
    /**
     * 
     * @type {number}
     * @memberof PortfolioDTOWithDetailsV3
     */
    'totalSpent': number;
    /**
     * 
     * @type {number}
     * @memberof PortfolioDTOWithDetailsV3
     */
    'totalReceived': number;
    /**
     * 
     * @type {number}
     * @memberof PortfolioDTOWithDetailsV3
     */
    'xirr'?: number;
    /**
     * 
     * @type {string}
     * @memberof PortfolioDTOWithDetailsV3
     */
    'riskAssetView': PortfolioDTOWithDetailsV3RiskAssetViewEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum PortfolioDTOWithDetailsV3AccessTypeEnum {
    Active = 'ACTIVE',
    Draft = 'DRAFT',
    Hidden = 'HIDDEN',
    Deleting = 'DELETING'
}
/**
    * @export
    * @enum {string}
    */
export enum PortfolioDTOWithDetailsV3WorkgroupTypeEnum {
    Client = 'CLIENT',
    Internal = 'INTERNAL',
    Global = 'GLOBAL',
    Model = 'MODEL'
}
/**
    * @export
    * @enum {string}
    */
export enum PortfolioDTOWithDetailsV3PortfolioTypeEnum {
    Live = 'LIVE',
    Paper = 'PAPER'
}
/**
    * @export
    * @enum {string}
    */
export enum PortfolioDTOWithDetailsV3CurrencyCodeEnum {
    Eur = 'EUR',
    Gbp = 'GBP',
    Aud = 'AUD',
    Nzd = 'NZD',
    Usd = 'USD',
    Kwd = 'KWD',
    Jod = 'JOD',
    Chf = 'CHF',
    Cad = 'CAD',
    Sgd = 'SGD',
    Ils = 'ILS',
    Qar = 'QAR',
    Aed = 'AED',
    Sar = 'SAR',
    Pln = 'PLN',
    Myr = 'MYR',
    Brl = 'BRL',
    Ron = 'RON',
    Try = 'TRY',
    Cny = 'CNY',
    Cnh = 'CNH',
    Hkd = 'HKD',
    Nok = 'NOK',
    Sek = 'SEK',
    Zar = 'ZAR',
    Egp = 'EGP',
    Mxn = 'MXN',
    Czk = 'CZK',
    Twd = 'TWD',
    Thb = 'THB',
    Uyu = 'UYU',
    Php = 'PHP',
    Ars = 'ARS',
    Rub = 'RUB',
    Inr = 'INR',
    Jpy = 'JPY',
    Isk = 'ISK',
    Pkr = 'PKR',
    Huf = 'HUF',
    Ngn = 'NGN',
    Krw = 'KRW',
    Idr = 'IDR',
    Dkk = 'DKK',
    Vnd = 'VND',
    Clp = 'CLP',
    Gbx = 'GBX',
    Ila = 'ILA',
    Zac = 'ZAC'
}
/**
    * @export
    * @enum {string}
    */
export enum PortfolioDTOWithDetailsV3PnlStatusEnum {
    Green = 'GREEN',
    Yellow = 'YELLOW',
    Agnostic = 'AGNOSTIC'
}
/**
    * @export
    * @enum {string}
    */
export enum PortfolioDTOWithDetailsV3IntegrationsEnum {
    AwaitingFiles = 'AWAITING_FILES',
    Active = 'ACTIVE'
}
/**
    * @export
    * @enum {string}
    */
export enum PortfolioDTOWithDetailsV3RiskAssetViewEnum {
    InstrumentAssetClass = 'INSTRUMENT_ASSET_CLASS',
    RiskAssetClass = 'RISK_ASSET_CLASS'
}


